<template>
  <PageTemplate>
    <v-container class="pb-8 pb-md-12 pb-lg-16 overflow-hidden">
      <v-row justify="center">
        <v-col
          cols="12"
          md="5"
          order="12"
          order-sm="12"
          order-md="0"
          class="pt-10"
        >
          <Title class="text-center mb-6 mb-lg-8">Atendimento</Title>
          <div class="d-flex flex-column">
            <v-btn
              v-if="informationsContacts.ombudsman"
              :href="informationsContacts.ombudsman"
              target="_blank"
              depressed
              rounded
              class="
                primary--text
                text-body-1 text-none
                font-weight-bold
                px-md-7 px-lg-8
              "
              :class="{ 'ml-2': informationsContacts.emergency_tel }"
            >
              <v-icon size="20"> far fa-comment-dots </v-icon>
              <span class="ml-2">Ouvidoria</span>
            </v-btn>

            <div class="d-flex mx-n5">
              <v-btn
                rounded
                depressed
                height="40px"
                min-width="auto"
                width="40px"
                :href="link"
                target="_blank"
                class="secondary--text text--lighten-1 ml-2"
                :title="title"
                text
                v-for="({ title, link, icon, size }, keySocial) in media"
                :key="keySocial"
              >
                <v-icon :size="size"> {{ icon }} </v-icon>
              </v-btn>
            </div>
            <div v-for="(contactItem, contactKey) in contact" :key="contactKey">
              <div class="mx-n3" v-if="!Array.isArray(contactItem)">
                <a
                  v-ripple
                  class="
                    secondary--text
                    text--lighten-1
                    font-weight-medium
                    text-none text-decoration-none
                    d-inline-flex
                    px-3
                    py-2
                  "
                  :href="contactItem.link"
                  :target="contactItem.target"
                >
                  <v-sheet
                    color="transparent"
                    width="20px"
                    class="d-inline-flex justify-center mr-3"
                  >
                    <v-icon
                      class="secondary--text text--lighten-1"
                      :size="contactItem.size"
                    >
                      {{ contactItem.icon }}
                    </v-icon>
                  </v-sheet>
                  {{ contactItem.title }}
                </a>
              </div>
              <div v-else>
                <div
                  class="mx-n3"
                  v-for="(
                    { title, link, target, icon, size }, key
                  ) in contactItem"
                  :key="key"
                >
                  <a
                    v-ripple
                    class="
                      secondary--text
                      text--lighten-1
                      font-weight-medium
                      text-none text-decoration-none
                      d-inline-flex
                      px-3
                      py-2
                    "
                    :href="link"
                    :target="target"
                  >
                    <v-sheet
                      color="transparent"
                      width="20px"
                      class="d-inline-flex justify-center mr-3"
                    >
                      <v-icon
                        class="secondary--text text--lighten-1"
                        :size="size"
                      >
                        {{ icon }}
                      </v-icon>
                    </v-sheet>
                    {{ title }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="7" order="0" order-md="12" class="pt-10">
          <Title class="text-center mb-6 mb-lg-8">Fale Conosco</Title>
          <Form />
        </v-col>
      </v-row>
    </v-container>

    <div v-if="map" class="map" v-html="map"></div>
  </PageTemplate>
</template>

<script>
import { getContact, getSocial } from "../../config";
import PageTemplate from "../templates/Page.vue";
import Title from "../widgets/Title.vue";
import Form from "../forms/Contact.vue";

export default {
  computed: {
    contacts() {
      return this.$rest("informations-contacts").item;
    },
    medias() {
      return this.$rest("informations-medias").item;
    },
    media() {
      return getSocial(this.medias);
    },
    contact() {
      return getContact(this);
    },
    map() {
      return this.contacts.map;
    },
    informationsContacts() {
      return this.$rest("informations-contacts").item;
    },
  },
  mounted() {
    this.$rest("informations-medias").get({
      save: (state, data) => (state.item = data),
    });

    this.$rest("informations-contacts").get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    PageTemplate,
    Title,
    Form,
  },
};
</script>

<style lang="scss">
.map {
  height: 450px;
  width: 100%;
  @media screen and (max-width: 600px) {
    height: 400px;
  }
  iframe {
    height: 100% !important;
    width: 100% !important;
  }
}
</style>
